import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import handleKeyPress from '../../common/handleKeyPress';
import RadioButton from '../RadioButton';
import * as Styled from './styles';

export const OPTION_DIRECTION = {
    TOP: 'TOP',
    RIGHT: 'RIGHT',
    BOTTOM: 'BOTTOM',
    LEFT: 'LEFT',
};

const Option = ({ text, value, onSelect, direction, margin, multiple }) => {
    const [isSelected, setIsSelected] = useState(value);

    useEffect(() => {
        if (value !== isSelected) {
            setIsSelected(value);
        }
    }, [value, isSelected, setIsSelected]);

    // when multiple, value will be used to clear and set the state dynamically,
    // while when single, value will be set to true or false statically as initial state.
    const onContainerClick = () => {
        if (multiple) {
            onSelect(true);
        } else {
            setIsSelected(true);
            onSelect(true);
        }
    };

    return (
        <Styled.OptionContainer margin={margin} direction={direction}>
            <Styled.OptionClickableContainer
                direction={direction}
                onClick={onContainerClick}
                onKeyDown={(e) => handleKeyPress(e, onContainerClick)}
            >
                <RadioButton value={isSelected} />
                <Styled.OptionText direction={direction}>{text}</Styled.OptionText>
            </Styled.OptionClickableContainer>
        </Styled.OptionContainer>
    );
};

Option.defaultProps = {
    onSelect: null,
    direction: OPTION_DIRECTION.LEFT,
    margin: '0',
    multiple: false,
};

Option.propTypes = {
    text: PropTypes.string.isRequired,
    value: PropTypes.bool.isRequired,
    onSelect: PropTypes.func,
    direction: PropTypes.oneOf(Object.values(OPTION_DIRECTION)),
    margin: PropTypes.string,
    multiple: PropTypes.bool,
};

export default Option;
